// src/context/SiteDataContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import { getAbout, getGallery, getTeam, getClients } from '../lib/supabase';

const SiteDataContext = createContext(null);

export function SiteDataProvider({ children }) {
  const [state, setState] = useState({
    about: null,   // { 1: {image_url, body}, 2: {image_url, body} }
    gallery: null, // [{ filename, alt }]
    team: null,    // [{ slug, name, role, image, bio }]
    clients: null, // [{ name, logo, link }]
    loading: true,
    error: null,
  });

  useEffect(() => {
    Promise.all([getAbout(), getGallery(), getTeam(), getClients()])
      .then(([about, gallery, team, clients]) => {
        setState({ about, gallery, team, clients, loading: false, error: null });
      })
      .catch((err) => {
        console.error('Supabase fetch error:', err);
        setState((prev) => ({ ...prev, loading: false, error: err.message }));
      });
  }, []);

  return <SiteDataContext.Provider value={state}>{children}</SiteDataContext.Provider>;
}


export function useSiteData() {
  const ctx = useContext(SiteDataContext);
  if (!ctx) throw new Error('useSiteData must be used inside SiteDataProvider');
  return ctx;
}